<p>Sleepy Dragon Games Inc. is an indie game design company based out of Regina, SK. Though its current team is small, each developer and writer is passionate about creating fun, unique experiences.
</p>
